import Configs from "../config";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

export interface GetDomainInfoResponse {
  domain: Domain;
  receiving_dns_records: IngDNSRecord[];
  sending_dns_records: IngDNSRecord[];
}

export interface Domain {
  created_at: string;
  id: string;
  is_disabled: boolean;
  name: string;
  require_tls: boolean;
  skip_verification: boolean;
  smtp_login: string;
  smtp_password: string;
  spam_action: string;
  state: string;
  type: string;
  web_prefix: string;
  web_scheme: string;
  wildcard: boolean;
}

export interface IngDNSRecord {
  cached: string[];
  priority?: string;
  record_type: RecordType;
  valid: Valid;
  value: string;
  name?: string;
}

export enum RecordType {
  Cname = "CNAME",
  MX = "MX",
  Txt = "TXT",
}

export enum Valid {
  Unknown = "unknown",
  Valid = "valid",
}

const getDomainInfo = async (): Promise<GetDomainInfoResponse> => {
  const userUid = localStorageGetItem("USER_UID");
  const response = await fetch(
    `${Configs.SERVER_URL}/mailgun/userUid/${userUid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
      },
    }
  );

  const responseObject: DefaultResponse<GetDomainInfoResponse> =
    await response.json();
  if (responseObject.status === "ok") {
    return responseObject.data as GetDomainInfoResponse;
  }

  throw new Error(responseObject.code);
};

export const MailgunApi = {
  getDomainInfo,
};
